export { default } from "./AdSense";
